import React from "react"
import HeadingSkeleton from "../../../components/skeletons/HeadingSkeleton";
import {Skeleton} from "antd";
import {DotChartOutlined} from '@ant-design/icons';

export default function ProgressChartSkeleton() {
    return(
        <div className={'chart-box'}>
            <div className={'chart-box-header'}>
                <div>
                    <h3><HeadingSkeleton maxWidth={200} height={10} block={true}/></h3>
                    <h4><span><HeadingSkeleton maxWidth={300} height={30}/></span></h4>
                </div>
                <div>
                    <h4><span><HeadingSkeleton maxWidth={100} height={30}/></span></h4>
                </div>
            </div>
            <div className={'w-100 pb-5'}>
                <Skeleton.Node active={true}
                               style={{
                                   width: '100%',
                                   height: 320,
                               }}
                               block={true}
                               size={'large'}
                >
                    <DotChartOutlined
                        style={{
                            fontSize: 40,
                            color: '#bfbfbf',
                        }}
                    />
                </Skeleton.Node>
            </div>

        </div>
    )
}